import React, 
       { useEffect, 
         useState }                 from 'react';
import { useNavigate }              from 'react-router-dom';
import { Container, 
         Form, 
         Row, 
         Col,
         Button }                   from 'react-bootstrap';
import { BsTrashFill }              from 'react-icons/bs';
import api                          from './AxiosConfig';

function GoalDetailsUpdateCL( { selGoal, refresh } ) {
  const [goal,             setGoal]             = useState();
  const [checklistItems,   setChecklistItems]   = useState();
  const [newChecklistItem, setNewChecklistItem] = useState( { item_description: "",  
                                                              item_long_description: "", 
                                                              repeat_pattern: "NA", 
                                                              item_due: ""});
  const [message,          setMessage]          = useState( "" );
  const navigate                                = useNavigate();

 useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
    }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getGoalChecklistItems() {
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/checklists/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  setChecklistItems(response.data);
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getGoalChecklistItems();
  }, [goal]); 
 
  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
       
  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGoal((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateDetails = async () => {
       try {
           const response = await api.put(`/site/goals/${encodeURIComponent(goal.id)}`, { goal }, {withCredentials: true });
           setMessage(response.data.message);
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }
       
  const handleArchiveGoal = async () => {
        try {
            const response = await api.put(`/site/goals/archived/${encodeURIComponent(goal.id)}/1`, { goal }, {withCredentials: true });
            setMessage(response.data.message);  // Display success message from server
            navigate('/status', {});
        } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
            } else {
                setMessage('An error occurred during update');
            }
        }
    };

  const updateClItemAtIndex = (e, index) => {
      const { name, value } = e.target;
      setChecklistItems(prev =>
          prev.map((item, idx) =>
          idx === index
          ? { ...item, [name]: value }   
          : item                           
          )
    );
  };

  const updateNewClItem = (e) => {
      const { name, value } = e.target;
      setNewChecklistItem( (prevData) => ({
        ...prevData,
        [name]: value,
      }));
  };

  const handleUpdateClItems = async () => {
       try {
           for (let c = 0; c < checklistItems.length ; c++) {
               const response = await api.put(`/site/checklists/${encodeURIComponent(goal.id)}/${encodeURIComponent(checklistItems[c].id)}`, { checklistItem: checklistItems[c] }, {withCredentials: true });
               console.log("update:" + c + " = " + JSON.stringify(checklistItems[c]) + " response:" + response.data.message);
               setMessage(response.data.message); 
           }
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }

  const handleAddClItem = async () => {
       try {
           const response = await api.put(`/site/checklists/${encodeURIComponent(goal.id)}`, { checklistItem: newChecklistItem }, {withCredentials: true });
           setNewChecklistItem({ item_description: "", item_due: ""});
           setMessage(response.data.message); 
           setNewChecklistItem( { item_description: "",  
                                  item_long_description: "", 
                                  repeat_pattern: "NA", 
                                  item_due: ""});
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }

  const handleDeleteClItem = async (i) => {
       try {
           const response = await api.delete(`/site/checklists/${encodeURIComponent(checklistItems[i].id)}`, {withCredentials: true });
           setMessage(response.data.message); 
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }

  return (
      <>
      { goal && checklistItems ? (
      <>
      <Container>
      <Form>
        {/* Goal Title */}
        <Form.Group as={Row} className="mb-3" controlId="formTitle">
          <Form.Label column className="text-end">
            Title
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_title} name="goal_title" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Goal Description */}
        <Form.Group as={Row} className="mb-3" controlId="formDescription">
          <Form.Label column  className="text-end">
            Description
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_description} name="goal_description" onChange={handleInputChange} />
          </Col>
        </Form.Group>
 
        {/* Short Code */ }
        <Form.Group as={Row} className="mb-3" controlId="formShortcode">
          <Form.Label column  className="text-end">
            Short Code
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.shortcode} name="shortcode" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Target Date */}
        <Form.Group as={Row} className="mb-3" controlId="formTargetDate">
          <Form.Label column  className="text-end">
            Target Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.target_date)} name="target_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Start Date */}
        <Form.Group as={Row} className="mb-3" controlId="formStartDate">
          <Form.Label column  className="text-end">
            Start Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.start_date)} name="start_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
       
        {/* Submit Button */}
        <Form.Group as={Row} >
          <Col>
            <Button variant="primary" size="sm" onClick={() => handleUpdateDetails()}>
              Update Details
            </Button>
          </Col>
          <Col className="text-end">
            <Button variant="primary" size="sm" onClick={() => handleArchiveGoal()}>
              Archive Goal
            </Button>
          </Col>
        </Form.Group>
      </Form>
      <Row><Col>{message}</Col></Row>
      </Container>
      <div className={"card-goal-seperator"}>Edit Checklist Items</div>
      <Form>
      { checklistItems.map( (item, index) => (
         <>
         <div className={"content-container checklist-status-" + item.item_complete + "-" + item.is_overdue} >
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
             <Form.Control className={"w-100 flex-grow-1"} type="text" value={item.item_description} name="item_description" onChange={e => updateClItemAtIndex( e, index)} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
             <Form.Control type="date" value={formatDate(item.item_due)} name="item_due" onChange={e=> updateClItemAtIndex( e, index)} />
             <BsTrashFill  onClick={() => handleDeleteClItem(index)}/>
           </div>
         </div>
         <div className={"content-container checklist-status-" + item.item_complete + "-" + item.is_overdue} >
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
             <Form.Control className="w-100 flex-grow-1" type="text" value={item.item_long_description} name="item_long_description" onChange={e => updateClItemAtIndex( e, index)} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
             <Form.Control type="text" size={5} value={item.repeat_pattern} name="repeat_pattern" onChange={e=> updateClItemAtIndex( e, index)} />
           </div>
         </div>
         </>
      ))} 
         <Form.Group as={Row} >
           <Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateClItems()}>Update Checklist</Button></Col>
         </Form.Group>
      </Form>
      <div className={"card-goal-seperator"}>Create New Item</div>             
      <Form>
         <div className="content-container">
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
               <Form.Control type="text" className={"w-100 flex-grow-1"} value={newChecklistItem.item_description} name="item_description" onChange={e => updateNewClItem( e )} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
               <Form.Control type="date" value={formatDate(newChecklistItem.item_due)} name="item_due" onChange={e=> updateNewClItem( e )} />    
               <Button variant="primary" size="sm" onClick={() => handleAddClItem()}>+</Button>
           </div>
         </div>
         <div className="content-container">
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
               <Form.Control className={"w-100 flex-grow-1"} type="text" value={newChecklistItem.item_long_description} name="item_long_description" onChange={e => updateNewClItem( e )} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
               <Form.Control type="text" size={5} value={newChecklistItem.repeat_pattern} name="repeat_pattern" onChange={e=> updateNewClItem( e )} />    
           </div>
         </div>
      </Form>
             
             </> ) : ( <p>Loading data...</p> )}
    </>           
  );
}

export default GoalDetailsUpdateCL;
